module.exports = __webpack_public_path__ + "img/arrow-right.1bced955.svg";